import type { AcademyFormat } from "@/features/academy-locations/schema";

export const FORMAT_LABELS: Record<AcademyFormat, string> = {
  drive_through: "Drive-Through",
  campus: "Campus",
  compact: "Compact",
  mobility_hub: "Mobility Hub",
};

export const STATUS_LABELS = {
  proposed: "Proposed area · Premises to be identified",
  premises_secured: "Premises secured",
  open: "Open",
} as const;

/** "390 m" under a kilometre, "8.8 km" above. */
export function distance(km: number) {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}

/** Straight-line distance between two points, in kilometres. */
export function kilometresBetween(
  a: { latitude: number; longitude: number },
  b: { latitude: number; longitude: number },
) {
  const radians = (degrees: number) => (degrees * Math.PI) / 180;
  const dLat = radians(b.latitude - a.latitude);
  const dLng = radians(b.longitude - a.longitude);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(radians(a.latitude)) *
      Math.cos(radians(b.latitude)) *
      Math.sin(dLng / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(h));
}

/** Where a location's "Register your interest" goes: the registration with it chosen. */
export function registerHref(slug: string) {
  return `/become-a-das-centre?location=${encodeURIComponent(slug)}`;
}

export const SUGGEST_HREF = "/become-a-das-centre?location=suggest";
